
<div class="modal-wrapper">
    <div class="modal-body">
        <ng-template #container></ng-template>
    </div>
    <span class="form-invalid">{{ formularioInvalido }}</span>
    @if (data.showActionsButtons === true) {
        <div class="modal-buttons">
        <lib-ribera-default-btn
        style="width: 100%;"
        *ngIf="data.showCancel"
        variant="outline"
        (press)="cancel()">
        {{ data.cancelText }}
        </lib-ribera-default-btn>

        <lib-ribera-default-btn
        style="width: 100%;"
        (press)="close()">
        {{ data.buttonText }}
        </lib-ribera-default-btn>
    </div>
    }
</div>
